import { render, staticRenderFns } from "./RemoveClassDialog.vue?vue&type=template&id=1bd2d401&scoped=true&"
import script from "./RemoveClassDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveClassDialog.vue?vue&type=script&lang=js&"
import style0 from "./RemoveClassDialog.vue?vue&type=style&index=0&id=1bd2d401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd2d401",
  null
  
)

export default component.exports